import { Component, OnInit } from '@angular/core';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';

@Component({
    selector: 'app-projects-widget',
    templateUrl: './projects-widget.component.html',
    styleUrls: ['../base-widget/base-widget.component.scss', './projects-widget.component.scss'],
    standalone: false
})
export class ProjectsWidgetComponent extends BaseWidgetComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
